export enum SearchEventsTypes {
  ListEventsRequest = 'SearchService.ListEvents.Request',
  ListEventsSuccess = 'SearchService.ListEvents.Success',
  ListEventsFailure = 'SearchService.ListEvents.Failure',
}
